<template>
  <div class="gmb-attribute-item group" v-if="attribute">
    <div class="attribute-name">
      {{ attribute.displayName }}
    </div>
    <div class="chip-group">
      <GmbAttributeChip
        v-for="item in attribute.options"
        :key="item.name"
        :name="item.displayName"
        :value="isActive(item.name)"
        :delete-mode="deleteMode"
        @input="setValues(item.name)"
      ></GmbAttributeChip>
    </div>
  </div>
</template>

<script>
import GmbAttributeItem from "@/components/FacilityDetails/GmbAttributes/GmbAttributeItem.vue";

export default {
  name: "GmbAttributeItemRepeatedEnum",
  extends: GmbAttributeItem,
  watch: {
    attribute(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.selectedValues = newValue.value ? [...newValue.value] : [];
        this.onSelect(this.selectedValues.length ? this.selectedValues : null);
      }
    }
  },
  methods: {
    setValues(valueName) {
      let foundIndex;
      const foundAttrValue = this.selectedValues.find((item, index) => {
        foundIndex = index;
        return item.name === valueName;
      });
      if (foundAttrValue) {
        if (!this.deleteMode) {
          if (foundAttrValue.value === true) {
            foundAttrValue.value = false;
          } else if (foundAttrValue.value === false) {
            this.selectedValues.splice(foundIndex, 1);
          }
        } else {
          this.selectedValues.splice(foundIndex, 1);
        }
      } else {
        const attrValue = {
          name: valueName,
          value: true
        };
        this.selectedValues.push(attrValue);
      }
      const newValue = this.selectedValues.length ? this.selectedValues : null;
      this.updateAttribute({ attributeId: this.attributeId, value: newValue });
    },
    isActive(valueName) {
      const currAttr = this.selectedValues.find(
        item => item.name === valueName
      );
      return currAttr ? currAttr.value : null;
    }
  }
};
</script>
